import { FC, ForwardedRef, forwardRef, memo } from "react";
import { Select as MantineSelect, SelectProps } from "@mantine/core";
import styles from "../select.module.scss";

interface SearchableSelectProps extends Omit<SelectProps, "error"> {
  width?: number;
  error?: string | boolean;

  intersectionCallback?: () => void;
  isLoading?: boolean;
}

export const SearchableSelect: FC<SearchableSelectProps> = memo(
  forwardRef(
    (
      { width, intersectionCallback, isLoading, ...props },
      ref: ForwardedRef<HTMLInputElement>,
    ) => {
      return (
        <MantineSelect
          {...props}
          ref={ref}
          style={{ width: width }}
          searchable={true}
          classNames={{
            input: styles.input,
          }}
          comboboxProps={{}}
        />
      );
    },
  ),
);
